import styled from "styled-components";
import { useState, useContext, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";

export default function TeamtypeEdit(props: Props) {
  const { teamType, setTeamType } = props;

  const typeOfTeams = [
    { label: "Country", value: "country" },
    { label: "Group", value: "group" },
    { label: "Reporting Team", value: "campus" },
  ];

  return (
    <>
      <Dropdown
        value={teamType}
        onChange={(e) => setTeamType(e.target.value as TeamType)}
        options={typeOfTeams}
        placeholder="Select a Role"
      />
    </>
  );
}

interface Props {
  teamType: TeamType;
  setTeamType: (teamType: TeamType) => void;
}
